import React from 'react';

// Web Entwicklung – Browserfenster mit Code-Zeichen </>
export const WebDevIcon = () => (
  <svg viewBox="0 0 80 80" className="service-reference-icon" aria-hidden="true">
    <rect x="12" y="16" width="56" height="48" rx="8" className="sri-stroke" />
    <line x1="12" y1="28" x2="68" y2="28" className="sri-stroke" />
    <circle cx="19" cy="22" r="1.8" className="sri-fill" />
    <circle cx="25" cy="22" r="1.8" className="sri-fill" />
    <circle cx="31" cy="22" r="1.8" className="sri-fill" />
    <polyline points="34,40 28,46 34,52" className="sri-stroke sri-code sri-code-l" />
    <polyline points="46,40 52,46 46,52" className="sri-stroke sri-code sri-code-r" />
    <line x1="42" y1="38" x2="38" y2="54" className="sri-accent" />
  </svg>
);

// App Entwicklung – Smartphone mit App-Raster
export const AppDevIcon = () => (
  <svg viewBox="0 0 80 80" className="service-reference-icon" aria-hidden="true">
    <rect x="26" y="10" width="28" height="60" rx="7" className="sri-stroke" />
    <line x1="35" y1="16" x2="45" y2="16" className="sri-stroke" />
    <rect x="32" y="24" width="7" height="7" rx="2" className="sri-fill sri-tile sri-tile-1" />
    <rect x="41" y="24" width="7" height="7" rx="2" className="sri-fill sri-tile sri-tile-2" />
    <rect x="32" y="33" width="7" height="7" rx="2" className="sri-fill sri-tile sri-tile-3" />
    <rect x="41" y="33" width="7" height="7" rx="2" className="sri-fill sri-tile sri-tile-4" />
    <circle cx="40" cy="63" r="2.4" className="sri-accent-fill" />
  </svg>
);

// UI/UX Design – Zeichenstift auf Artboard
export const UiUxIcon = () => (
  <svg viewBox="0 0 80 80" className="service-reference-icon" aria-hidden="true">
    <rect x="10" y="12" width="46" height="46" rx="8" className="sri-stroke" />
    <line x1="10" y1="25" x2="56" y2="25" className="sri-stroke sri-dashed" />
    <line x1="23" y1="25" x2="23" y2="58" className="sri-stroke sri-dashed" />
    <circle cx="23" cy="25" r="3.5" className="sri-accent-fill sri-anchor" />
    <g className="sri-pen">
      <path d="M40 62 L60 42 L67 49 L47 69 L37 71 Z" className="sri-stroke" />
      <line x1="56" y1="46" x2="63" y2="53" className="sri-stroke" />
      <path d="M37 71 L40 62 L47 69 Z" className="sri-accent-fill-shape" />
    </g>
  </svg>
);